import {
    type UpdateProfileResponseType,
    type UpdateProfilePayloadType
} from "./type";
import {
    request
} from "../request";

const UpdateProfile = async (payload: UpdateProfilePayloadType): Promise<UpdateProfileResponseType> => {
    return await request<UpdateProfileResponseType>("/auth/updateProfile", {
        body: JSON.stringify(payload),
        method: "POST"
    });
};

export default UpdateProfile;
